<template>
  <div>
    <div class="article__preview-grid"
      v-for="(post, index) in posts"
      :key="index">
      <div class="article__preview-body">
        <router-link
          class="article__preview-link"
          :to="`/article/${post.id}/${post.slug}`" />
        <figure>
          <img class="article__preview-img"
            :src="post.image.url"
            :alt="post.alt"
            :width="post.image.width"
            :height="post.image.height">
          <figcaption class="sr-only"></figcaption>
        </figure>
        <article>
          <dynamic-heading :level="hLevel" class="article__preview-heading">{{post.title}}</dynamic-heading>
          <div class="article__preview-meta">
            <strong>Category:</strong> {{ post.category.title }}
            <span class="divider">//</span>
            <strong>Published:</strong> {{ post.datePublished | formatDate('PPpp') }}
          </div>
          <div v-html="post.excerpt" class="article__preview-text"></div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    posts: Array,
    hLevel: Number
  },
  data () {
    return {}
  },
  computed: {},
  methods: {},
  mounted: function () {},
  watch: {}
}
</script>

<style scoped></style>
